export const isDataEmpty = <Data>(data: unknown): data is Data => {
  // null or undefined
  if (typeof data === "undefined" || data === null) return true;

  // String type
  if (typeof data === "string" && !data) return true;

  // Array type
  if (Array.isArray(data) && !data.length) return true;

  // Object type
  if (typeof data === "object" && !Object.keys(data).length) return true;

  // Has data
  return false;
};

// https://youmightnotneed.com/lodash#isNil
// Here we want to keep the double equal instead of a 3 triple equal
export const isNil = (val: unknown) => val == null;
